<template>
  <div>
    <PageTitle
      title="Create Dish"
      :backBtn="true"
      :permission="'Customer Create'"
      :showLoading="isLoading"
    />
    <ValidationObserver ref="observer">
      <v-container fluid class="lighten-12">
        <v-row>
          <v-col cols="8">
            <v-row>
              <v-col cols="12">
                <v-card class="lighten-12">
                  <v-card-title>General </v-card-title>
                  <v-container
                    fluid
                    class="light gray lighten-12 container-card"
                  >
                    <form>
                      <v-row>
                        <template v-if="messages">
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            dense
                            outlined
                            type="error"
                            >{{ msg }}</v-alert
                          >
                        </template>
                      </v-row>

                      <v-row>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name=" Name"
                            rules="required|no_spaces_only"
                            vid="name"
                          >
                            <v-text-field
                              hide-details="auto"
                              dense
                              outlined
                              v-model="Dish.name"
                              :error-messages="errors"
                              label="Name"
                              required
                              @blur="Dish.name = Dish.name.trim()"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Code"
                            rules="required|no_spaces_only"
                            vid="code"
                          >
                            <v-text-field
                              hide-details="auto"
                              dense
                              outlined
                              v-model="Dish.code"
                              :error-messages="errors"
                              label="Code"
                              required
                              @blur="Dish.code = Dish.code.trim()"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Average Cooking Time"
                            rules="duration_cook_time"
                            vid="avrage_gooking_time"
                          >
                            <v-text-field
                              hide-details="auto"
                              dense
                              outlined
                              label="Average Cooking Time"
                              placeholder="Minutes (e.g. 15) or HH:MM (e.g. 01:15)"
                              prepend-icon="mdi-timer-outline"
                              v-model="Dish.avrage_gooking_time"
                              :error-messages="errors"
                              @blur="
                                Dish.avrage_gooking_time = normalizeCookingTime(
                                  Dish.avrage_gooking_time
                                )
                              "
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Is Ready Made"
                            rules="required"
                          >
                            <v-select
                              hide-details="auto"
                              dense
                              item-text="name"
                              item-value="value"
                              :items="status"
                              :error-messages="errors"
                              v-model="Dish.is_ready_made"
                              label="Is Ready Made"
                              outlined
                            ></v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </form>
                  </v-container>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-row>
                  <v-col cols="12" md="12" class="pa-3">
                    <v-card class>
                      <v-tabs v-model="tab" background-color="white" color="primary" slider-color="primary">
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab
                          :disabled="item.disabled"
                          v-for="item in items"
                          :key="item.tab"
                        >
                          {{ item.tab }}
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="tab">
                        <v-tab-item
                          v-for="(item, index) in items"
                          :key="item.tab"
                        >
                          <Category
                            v-if="item.tab === 'Categories'"
                            ref="Categories"
                            v-on:nextTab="moveTab(1, index)"
                          />
                          <Ingredients
                            v-if="item.tab === 'Ingredients'"
                            @nextTab="GetDataIngreients()"
                            ref="Ingredients"
                          />
                          <Types
                            v-if="item.tab === 'Types'"
                            ref="Types"
                            @nextTab="moveTab(2, index)"
                          />
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="4">
            <v-card>
              <v-col cols="12 p-0">
                <FileUpload
                  ref="fileUpload"
                  title="Image"
                  :multiple="false"
                  v-model="selectedImages"
                  size="10000"
                  :types="['jpeg', 'png', 'jpg']"
                  :showPreview="true"
                  :camera="true"
                />
              </v-col>
            </v-card>
          </v-col>
        </v-row>

        <v-row> </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="12" class="content-flex-end">
            <v-btn depressed small class="text-white btn_medium" @click="clear"
              >Clear</v-btn
            >
            <v-btn
              depressed
              small
              class="text-white btn_blue btn_medium w-100"
              @click="submit"
              :disabled="isDisabledSubmit"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </ValidationObserver>
  </div>
</template>

<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import Category from "./DishCategory/DishCategoryCreate";
import Types from "./DishType/DishTypesCreate";
import Ingredients from "./DIshIngredient/DishIngredientsCreate";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

import { Dishes } from "../../../models/Dishes";
import { ProductCategory } from "../../../models/ProductCategory";
import FileUpload from "@/components/base/FileUpload";
setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("duration_cook_time", {
  validate: (value) => {
    if (value === null || value === undefined) return true;
    const raw = String(value).trim();
    if (!raw) return true;

    // minutes-only
    if (/^\d+$/.test(raw)) return true;

    // HH:MM where MM is 0-59
    const match = raw.match(/^(\d{1,2})\s*:\s*(\d{1,2})$/);
    if (!match) return false;
    const hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    if (!Number.isFinite(hours) || hours < 0) return false;
    if (!Number.isFinite(minutes) || minutes < 0 || minutes > 59) return false;
    return true;
  },
  message: "Use minutes (e.g. 15) or HH:MM (e.g. 01:15)",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    selectedImages: "",
    status: [
      {
        name: "Yes",
        value: true,
      },
      {
        name: "No",
        value: false,
      },
    ],
    items: [
      { tab: "Categories", content: "this is credit tab", disabled: false },
      { tab: "Types", content: "this is credit tab", disabled: true },

      { tab: "Ingredients", content: "", disabled: true },
    ],
    tab: "Credit",
    checkbox: null,
    Dish: new Dishes(),
    isLoading: false,
    GetProductCategory: [],
    selectedCategory: [],
    selectedTypes: [],
    selectedIngredients: [],
    errors: [],
    messages: [],

    isDisabledSubmit: false,
    countries: { id: "", name: "" },
  }),
  components: {
    Category,
    Ingredients,
    Types,
    ValidationProvider,
    ValidationObserver,
    FileUpload,
  },
  methods: {
    normalizeCookingTime(value) {
      if (value === null || value === undefined) return "";
      const raw = String(value).trim();
      if (!raw) return "";

      // minutes-only
      if (/^\d+$/.test(raw)) {
        return String(parseInt(raw, 10));
      }

      // HH:MM
      const match = raw.match(/^(\d{1,2})\s*:\s*(\d{1,2})$/);
      if (!match) return raw;

      const hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return raw;

      const hh = String(hours).padStart(2, "0");
      const mm = String(minutes).padStart(2, "0");
      return `${hh}:${mm}`;
    },
    GetDataIngreients() {
      if (this.$refs.Ingredients.length == 1) {
        this.selectedIngredients = this.$refs.Ingredients[0].GetDatasIngredients();
      } else {
        this.selectedIngredients = this.$refs.Ingredients.GetDatasIngredients();
      }
    },
    moveTab(to, index) {
      if (to == 1) {
        if (this.$refs.Categories.length == 1) {
          this.selectedCategory = this.$refs.Categories[0].GetDatas();
        } else {
          this.selectedCategory = this.$refs.Categories.GetDatas();
        }
      }

      if (to == 2) {
        if (this.$refs.Types.length == 1) {
          this.selectedTypes = this.$refs.Types[0].GetDatasTypes();
        } else {
          this.selectedTypes = this.$refs.Types.GetDatasTypes();
        }
      }

      this.tab = to;
      this.items[index + 1].disabled = false;
    },

    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.CreateDish();
      } else if (isValid) {
      }
    },
    clear() {
      this.Dish = {};
    },

    GetProductCategorySingle(id) {},
    CreateDish() {
      if (!this.selectedCategory) {
        this.$toast.error("Choose a category before saving the dish.");
        return;
      }
      if (!this.selectedTypes || !this.selectedTypes.length) {
        this.$toast.error("Add a type and price before saving the dish.");
        return;
      }
      this.isLoading = true;
      this.isDisabledSubmit = true;
      let Credential = this.Dish;
      Credential.Categories = this.selectedCategory;
      const types = this.selectedTypes.map(function(item) {
        return {
          unit_id: item.id,
          price: item.price,
          is_default: item.sample,
          is_adjust: item.is_adjust ? item.is_adjust : false,
          quantity: item.quantity ? item.quantity : null,
        };
      });
      if (!types.some((type) => type.is_default)) types[0].is_default = true;
      if (types.some((type) => type.price === "" || type.price == null || Number.isNaN(Number(type.price)))) {
        this.$toast.error("Enter a price for each dish type.");
        return;
      }
      Credential.Types = types;
      Credential.Ingredients = (this.selectedIngredients || []).map(function(item) {
        return {
          ingredient_id: item.id,
          price: item.price,
        };
      });
      this.$store
        .dispatch("dish/CreateDish", new Dishes().toRequest(Credential))
        .then(async (res) => {
          this.succeeed = true;
          await this.UploadImage(res.data.id)
            .then((res) => {
              this.succeeed = true;
            })
            .catch((err) => {
              this.$toast.error("Dish image upload failed");
              this.isLoading = false;
            });

          this.isDisabledSubmit = false;
          this.$router.push("/dishes");
          this.$toast.success("Dish added  successfully");
          this.isLoading = false;
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.messages = err.data.title;
          this.isLoading = false;
          this.isDisabledSubmit = false;
          this.$toast.error("Dish creation failed");
          // this.isDisabledSubmit = false;
        });
    },
    GetSubGeneralDatas() {
      this.Categories = this.$refs.GetCategory.GetDatas();
    },
    async UploadImage(id) {
      let formData = new FormData();
      formData.append("image", this.selectedImages);
      formData.append("id", id);
      console.log(this.selectedImages);
      return await this.$store.dispatch("dish/UploadDishImage", formData);
    },

    GetCountries() {
      this.$store
        .dispatch("GetCountries")
        .then((res) => {
          this.countries = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
  },
  created() {
    this.GetCountries();
    this.GetSubGeneralDatas();
  },
};
</script>
